/**
 * @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
 * @license AGPL-3.0
 *
 * This code is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 *
 * Any use of the work other than as authorized under this license or copyright law is prohibited.
 */

// useful for testing
let disabled = false
export function disableAnimation () { disabled = true }

// convenience function to fade in/out, similar to jQuery's own fadeIn/fadeOut, but thenable and simplified
export const fadeIn = async function ($el, duration = 200) { // 200ms equals jquery's 'fast'
  $el.show()
  if (!disabled) await Promise.all($el.get().map(node => node.animate({ opacity: [0, 1] }, duration).finished))
  return $el
}

export const fadeOut = async function ($el, duration = 200) {
  if (!disabled) await Promise.all($el.get().map(node => node.animate({ opacity: [1, 0] }, duration).finished))
  return $el.hide()
}
